import { render } from "./Socials.vue?vue&type=template&id=0cf31dbe&scoped=true"
const script = {}

import "./Socials.vue?vue&type=style&index=0&id=0cf31dbe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf31dbe"]])

export default __exports__